import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from 'src/app/services/storage.service';

interface City {
  name: string,
  code: string
}
@Component({
    selector: 'app-user-management-editor',
    templateUrl: './user-management-editor.component.html',
    styleUrls: ['./user-management-editor.component.scss'],
    standalone: false
})
export class UserManagementEditorComponent implements OnInit {


  cities: City[];
  selectedCity!: City;
  selectedCity1!: City;
  selectedCity2!: City;
  firstName: any;
  lastName : any;
  email : any;
  mobile : any;
  password : any;
  confirmpassword : any;


  userRole: string;

  constructor(private router: Router, private storageService: StorageService) { 

    this.cities = [
      {name: 'Rome', code: 'RM'},
      {name: 'London', code: 'LDN'},
      {name: 'Istanbul', code: 'IST'},
      {name: 'Paris', code: 'PRS'}
  ];

  }

  ngOnInit(): void {
    this.userRole = this.storageService.getRole() || '';
  }

  gotoDashboard() {
    this.userRole === 'CLIENT'
      ? this.router.navigate(['doqfy/dashboard'])
      : this.router.navigate(['doqfy/admin-dashboard']);
  }

  savePersonalDetails(){
    
  }

}
